import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tears': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M102.4 256.1C79.8 259.3 28.9 268.1 14.1 282.9-5 302-4.7 333.5 14.9 353.1S65.9 373 85.1 353.8C99.9 339 108.6 288.1 111.9 265.5 112.7 260 108 255.3 102.4 256.1zM625.8 282.9C611 268.1 560.1 259.4 537.5 256.1 532 255.3 527.2 260 528 265.6 531.2 288.2 540 339.1 554.8 353.9 574 373.1 605.4 372.8 625 353.2S645 302 625.8 282.9zM496.4 270.1C492.6 243.5 515.5 220.6 542.1 224.4 551 225.7 558.9 227.1 566.4 228.5 552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5C81.1 227.1 89 225.7 97.9 224.4 131.1 220.5 146.5 249.7 143.6 270.1 131.8 352.4 113.7 370.5 107.8 376.5 106.9 377.4 105.8 378.1 104.8 379 147.5 453.6 227.8 504 320 504S492.5 453.6 535.2 378.9C534.2 378 533.1 377.4 532.2 376.4 526.3 370.5 508.2 352.4 496.4 270.1zM400 152C423.8 152 452.7 181.3 456 223.4 456.7 232 445.2 235.4 441.1 227.9L431.6 210.9C423.9 197.2 412.4 189.3 400.1 189.3S376.3 197.2 368.6 210.9L359.1 227.9C354.9 235.3 343.5 231.9 344.2 223.4 347.3 181.3 376.2 152 400 152zM240 152C263.8 152 292.7 181.3 296 223.4 296.7 232 285.2 235.4 281.1 227.9L271.6 210.9C263.9 197.2 252.4 189.3 240.1 189.3S216.3 197.2 208.6 210.9L199.1 227.9C194.9 235.3 183.5 231.9 184.2 223.4 187.3 181.3 216.2 152 240 152zM320 432C259.4 432 185.5 393.7 176.2 338.7 174.2 327 185.4 317.1 196.9 320.8 227.1 330.5 272 336 320 336S412.9 330.5 443.1 320.8C454.5 317.1 465.7 326.9 463.8 338.7 454.5 393.7 380.6 432 320 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tears.js
// module id = fJmN
// module chunks = 144